import {
  EditorReadyOptions,
} from '@wix/platform-editor-sdk';

export async function getCurrentVersion(editorReadyOptions: EditorReadyOptions) {
  const scriptUrl: string = editorReadyOptions?.initialAppData?.editorScriptUrl;
  return scriptUrl.match(/[0-9]+.[0-9]+.[0-9]+/g)[0];
}
